import { many, attr} from 'redux-orm';
import Model from '../base-model';
import programReducers from './program.reducer';
import { programActions } from './program.action';

/**
 * Program
 * @typedef {Object} Program
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} summary
 * @property {string} status
 * @property {string} image
 * @property {string} video 
 * @property {Date} startDateTime 
 * @property {Date} enrollDate
 * @property {number} price
 * @property {number} capacity
 * @property {number} courseCount
 * @property {string} programType
 * @property {Course} courses
 * @property {Attachments[]} attachments
 * @property {number} progress
 */

export class Program extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case programActions.save:
            programReducers.save(session, action.program);
            break;
        case programActions.remove:
            programReducers.remove(session, action.id);
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Program: ${this.title}`
    }
}

Program.modelName = 'Program';

Program.fields = {
    id: attr(),
    title: attr(),
    description: attr(),
    summary: attr(),
    status: attr(),
    image: attr(),
    video: attr(),
    courses: many('Course'),
    courseCount: attr(),
    startDateTime: attr(),
    price: attr(),
    programType: attr(),
    capacity: attr(),
    enrollDate: attr(),
    attachments: many('Attachment'),
    progress: attr(),
}
